import { activeTabScrollIntoView, clickFromHash } from "@sky-it-livedata/common-web-app-utils";
import { heroSlimSticky } from "../utils/lgp-hero";
import { loadClientWidgets } from "../utils/loadClientWidgets";
import { widgetsLgp } from "../widgets";
import { checkSprintRaceLabel } from '../utils/motogp-sprint-race';
import { handleLgpTabs } from "../utils/handle-lgp-tabs";

import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";
import { ageCalc } from "@sky-it-livedata/common-web-app-utils/browser";
import resumeAthletePages from "../utils/resume-athlete-pages";

export const initClient = () => loadClientWidgets(widgetsLgp);

initClient();

document.addEventListener('DOMContentLoaded', () => {
    ageCalc();
    resumeAthletePages();
    heroSlimSticky();
    checkSprintRaceLabel();
    handleLgpTabs();
    activeTabScrollIntoView();
    clickFromHash();
});